import { AnyAction } from 'redux';
import { GET_LOCATIONS_LIST_FAILURE, GET_LOCATIONS_LIST_REQUEST, GET_LOCATIONS_LIST_SUCCESS } from '../constants/auth.constant';

const initialState = {
  loading: false,
  data: [],
  errMsg: '',
};

export const locationListReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case GET_LOCATIONS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        data: [],
        errMsg: '',
      };
    case GET_LOCATIONS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case GET_LOCATIONS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        errMsg: action.payload,
      };
    default:
      return state;
  }
};
